module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/at-d7b3791eb6679e92a2bd4447053ebc93.svg";